import { PageLayout } from "~/components/PageLayout";
import { LoginForm } from "~/features/auth/components/LoginForm";
import { useTrackPageVisit } from "~/hooks/useTrackPageVisit";

export const LoginPage = () => {
  useTrackPageVisit("app/login/visit");

  return (
    <PageLayout>
      <LoginForm />
    </PageLayout>
  );
};
